<template>
  <div>
    <div
      class="field"
      @click="showList()"
    >
      <a class="button">
        <span class="icon">
          <i class="far fa-chevron-left" />
        </span>
        <span>Back</span>
      </a>
    </div>
    <div class="content has-text-centered">
      <strong>{{ job.title }}</strong>
    </div>
    <div
      class="content"
      v-html="job.description"
    />
    <strong v-if="job.offers.length > 0">We offer</strong>
    <ul>
      <li v-for="offer in job.offers">
        {{ offer }}
      </li>
    </ul>
    <strong v-if="job.requirements.length > 0">Requirements</strong>
    <ul>
      <li v-for="requirement in job.requirements">
        {{ requirement }}
      </li>
    </ul>
    <p
      class="text-center"
      v-html="job.conclusion"
    />
  </div>
</template>

<script>
  export default {
    name: 'JobPage',
    props: ['job'],
    data () {
      return {}
    },
    computed: {},
    methods: {
      showList () {
        this.$emit('showList')
      }
    }
  }
</script>
